export const HEADER_VALUE_LINE_HEIGHT = '24px';

export const HEADER_VALUE_GAP = '0.6rem';

export const headerValueStyle = {
  fontSize: '20px',
  lineHeight: HEADER_VALUE_LINE_HEIGHT,
};

export const headerCountStyle = {
  ...headerValueStyle,
  paddingTop: HEADER_VALUE_GAP,
};
